var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tracking__State=Tracking, Type=Enabled",
    className: "tracking__State=Tracking, tracking__Type=Enabled",
    clipPath: "url(#tracking__clip0_19615_184531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tracking__Vector",
    className: "tracking__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.908 2.727c0-.967.784-1.75 1.75-1.75h7.107c.457 0 .895.178 1.221.496L22.56 12.75c1.028 1.001.48 2.746-.936 2.98l-4.771.787a.25.25 0 0 0-.206.204l-.841 4.85c-.243 1.4-1.965 1.942-2.967.934L1.416 10.993A1.75 1.75 0 0 1 .908 9.76V2.727Zm1.75-.25a.25.25 0 0 0-.25.25V9.76c0 .066.026.13.073.176l11.423 11.512a.25.25 0 0 0 .424-.133l.841-4.85a1.75 1.75 0 0 1 1.44-1.428l4.77-.787a.25.25 0 0 0 .134-.426L9.94 2.547a.25.25 0 0 0-.175-.07H2.658Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.801 7.527a.828.828 0 1 0 0-1.656.828.828 0 0 0 0 1.656Zm0 1.25a2.078 2.078 0 1 0 0-4.156 2.078 2.078 0 0 0 0 4.156Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tracking__clip0_19615_184531",
    className: "tracking__clip0_19615"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsTracking);
export default __webpack_public_path__ + "static/media/sidebar-icons-tracking.92efc2368afa7dbc5cdcfa0c5f110e2c.svg";
export { ForwardRef as ReactComponent };